import { Form, RegistrationField } from "sharedTypes"

export default (form: Form): RegistrationField[] => {
  const {
    plusOneNameEnabled = true,
    plusOneEmailEnabled = true,
    plusOneEmailRequired = false,
    translations: { fullName, emailAddress },
  } = form

  return [
    {
      name: fullName,
      enabled: plusOneNameEnabled,
      required: true,
      requiredLocked: true,
      fieldName: "plusOneName",
    },
    {
      name: emailAddress,
      enabled: plusOneEmailEnabled,
      required: plusOneEmailRequired,
      fieldName: "plusOneEmail",
    },
  ]
}
